import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { TwoFactorMethod } from '@/types/AuthState';
import type { VerificationDTO } from '@/types/DTOs';
import { isJWTExpired } from '@/store/utils/jwtDecoder';

export const resend2faCodeThunk = createAppAsyncThunk<
  VerificationDTO,
  { method: TwoFactorMethod },
  { rejectValue: { message: string; expired?: boolean } }
>(
  'auth/resend2faCode',
  async ({ method }, { getState, extra: { authService }, rejectWithValue }) => {
    const state = getState();
    const twoFactorToken = state.auth.regToken;

    if (twoFactorToken === undefined) {
      return rejectWithValue({ message: 'Missing session token' });
    }

    if (isJWTExpired(twoFactorToken)) {
      return rejectWithValue({
        message: 'Your session expired. Please log in again.',
        expired: true,
      });
    }

    try {
      return await authService.selectTwoFactorMethod({ twoFactorToken, method });
    } catch (caught) {
      const message = caught instanceof Error ? caught.message : 'Failed to resend 2FA code';
      return rejectWithValue({ message });
    }
  }
);
